import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import urlparam from 'urlparam';
import resolvePath from '../../../misc/resolvePath';
import ButtonLink from '../../elements/ButtonLink';
import Link from '../../elements/Link';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import WaitWhileBusy from '../../WaitWhileBusy';
import Screen from '../Screen';
import connectForm from './common/connectForm';
import './EventForm.scss';

class EventForm extends React.Component {
    componentDidMount() {
        this.skipEmptyScreenCheck(true);
    }
    componentDidUpdate() {
        this.skipEmptyScreenCheck();
    }
    render() {
        let {event, form, drafts, i18n} = this.props,
            eventForm = _(event.forms).find(ef => ef.id == form.id) || {},
            header = (
                <div>
                    <TopBarEvent event={event}>{i18n['label.your-requests']}</TopBarEvent>
                    <hr />
                </div>
            ),
            footer = (
                <div className="content">
                    <ButtonLink className="" style={event._local.styles.button} onClick={this.handleCreateResponse.bind(this)}>
                        {eventForm.button_title}
                    </ButtonLink>
                </div>
            );

        console.log(this.props);

        return (
            <Screen header={header} footer={footer}>
                <Scrollable>
                    <div className="content">
                        {this.props.drafts.length ? (
                            <div>
                                <h2>{i18n['label.pending']}</h2>
                                <ul className="EventForm--FormList">
                                    {drafts.map(draft => (
                                        <li key={draft.UID}>
                                            <Link href={'./' + draft.UID}>
                                                {this.props.summaryQuestions.map((question, i) => (
                                                    <p key={question.id} className={'text' + (i == 0 ? ' main' : '')}>
                                                        {(draft.answers[question.id] || []).join()}
                                                    </p>
                                                ))}
                                                <p className="text ">{moment(draft.createdAt).format('lll')}</p>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}
                        {this.props.uploading.length ? (
                            <div>
                                {/* <h2></h2> */}
                                <ul className="EventForm--FormList">
                                    {this.props.uploading.map(answer => (
                                        <li key={answer.UID}>
                                            {this.props.summaryQuestions.map((question, i) => (
                                                <p key={question.id} className={'text' + (i == 0 ? ' main' : '')}>
                                                    {(answer.answers[question.id] || []).join()}
                                                </p>
                                            ))}
                                            <p className="text ">{moment(answer.createdAt).format('lll')}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}
                    </div>
                </Scrollable>
            </Screen>
        );
    }
    handleCreateResponse() {
        app.history.push(resolvePath(app.history.location.pathname, 'create'));
    }
    skipEmptyScreenCheck(checkURLParams) {
        if (!this.props.hasAnswers) {
            if (checkURLParams && urlparam('create', false)) {
                this.handleCreateResponse();
            } else {
                app.history.replace(resolvePath(app.history.location.pathname, '..', '..'));
            }
        }
    }
}

const ConnectedEventForm = connectForm(
    connect((state, props) => {
        let drafts = _(state.forms.drafts)
            .filter(form => form.formId == props.formId)
            .value();

        return {
            drafts,
            uploading: _(state.forms.uploading)
                .filter(form => form.formId == props.formId)
                .value(),
            hasAnswers: drafts.length || state.forms.uploading.length,
            summaryQuestions: _(props.form.groups)
                .map(group => group.questions)
                .flatten()
                .compact()
                .filter(question => question.in_summary)
                .value(),
        };
    })(EventForm)
);

export default props => (
    <WaitWhileBusy>
        <ConnectedEventForm {...props.match.params} />
    </WaitWhileBusy>
);
